import { normalizeEmail } from "@/shared/utils/email";
const CREATOR_WELCOME_PENDING_KEY = "creator-welcome-pending";

export const markCreatorWelcomePending = (email: string) => {
	sessionStorage.setItem(CREATOR_WELCOME_PENDING_KEY, normalizeEmail(email));
};

export const isCreatorWelcomePending = (email: string) => {
	const pendingEmail = sessionStorage.getItem(CREATOR_WELCOME_PENDING_KEY);
	if (!pendingEmail) return false;
	if (pendingEmail !== normalizeEmail(email)) {
		clearCreatorWelcomePending();
		return false;
	}
	return true;
};

export const clearCreatorWelcomePending = () => {
	sessionStorage.removeItem(CREATOR_WELCOME_PENDING_KEY);
};
